import React from "react";
import PermissionPill from "../molecules/PermissionPill";
import ResourcePill from "../molecules/ResourcePill";
import ActionPill from "../molecules/ActionPill";
import TablePaginationFooter from "../../ui/molecules/TablePaginationFooter";
import type { PermissionItem } from "../../../hooks/usePermissions";

interface PermissionsTableProps {
  permissions: PermissionItem[];
  loading?: boolean;
  error?: string | null;
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}

const PermissionsTable: React.FC<PermissionsTableProps> = ({
  permissions,
  loading = false,
  error,
  page,
  pageSize,
  totalCount,
  totalPages,
  onPageChange,
  onPageSizeChange,
}) => {
  if (loading) {
    return (
      <div className="access-management-table-wrapper">
        <div className="text-center py-5 text-muted">
          Loading permissions...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="access-management-table-wrapper">
        <div className="text-center py-5 text-danger">{error}</div>
      </div>
    );
  }

  return (
    <>
      <div className="access-management-table-wrapper">
        <div className="table-responsive">
          <table className="access-management-table table align-middle table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th scope="col">Permission</th>
                <th scope="col">Resource</th>
                <th scope="col">Action</th>
                <th scope="col">Description</th>
              </tr>
            </thead>
            <tbody>
              {permissions.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center py-4 text-muted">
                    No permissions found
                  </td>
                </tr>
              ) : (
                permissions.map((permission) => (
                  <tr key={permission.id}>
                    <td>
                      <PermissionPill value={permission.code} />
                    </td>
                    <td>
                      <ResourcePill
                        value={permission.resource ?? "-"}
                      />
                    </td>
                    <td>
                      <ActionPill value={permission.action ?? "-"} />
                    </td>
                    <td>
                      <span className="permissions-table-description">
                        {permission.description || "-"}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <TablePaginationFooter
        page={page}
        totalPages={Math.max(1, totalPages)}
        pageSize={pageSize}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </>
  );
};

export default PermissionsTable;
